import React, { useState } from 'react';
import { ScrollView } from 'react-native';
import { Formik } from 'formik';
import { useAuthDispatch } from '../../auth/authContext';
import { SIGN_IN } from '../../auth/authTypes';
import {
  signIn,
  forgotPassword,
  forgotPasswordSubmit,
} from '../../auth/authService';
import ContainedButton from '../../components/styled/ContainedButton';
import EmailInput from '../../components/styled/EmailInput';
import GalanoGrotesqueText from '../../components/styled/GalanoGrotesqueText';
import PasswordInput from '../../components/styled/PasswordInput';
import HeaderOne from '../../components/styled/HeaderOne';
import View from '../../components/styled/View';
import VerificationCodeInput from '../../components/styled/VerificationCodeInput';
import Logo from '../../components/styled/Logo';
import {
  forgotPasswordSubmitSchema,
  resetPasswordSchema,
} from './validationSchema';
import {
  HEADER_ENTER_EMAIL,
  HEADER_ENTER_CODE,
  HEADER_FORGOT_PASSWORD,
} from './constants';
import styles from './styles';

const ForgotPasswordScreen = () => {
  const dispatch = useAuthDispatch();
  const [email, setEmail] = useState('');
  const [userReset, setUserReset] = useState(false);
  const [passwordLoading, setForgotPasswordLoading] = useState(false);
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const resetPassword = ({ email }) => {
    setForgotPasswordLoading(true);
    forgotPassword(email)
      .then((data) => {
        setUserReset(true);
        setEmail(email);
        setForgotPasswordLoading(false);
      })
      .catch((err) => {
        // const message = 'Incorrect email address'
        //  After 5 tries user will get this message: Attempt limit exceeded, please try after some time. TODO: Handle errors
        setForgotPasswordLoading(false);
        setErrorMessage(err.message);
        console.error(err);
      });
  };

  const confirmResetPassword = ({ code, newPassword }) => {
    setVerifyLoading(true);
    forgotPasswordSubmit(email, code, newPassword)
      .then(() => {
        setVerifyLoading(false);
        signIn(email, newPassword).then((response) => {
          const { attributes, signInUserSession } = response;
          const user = {
            token: signInUserSession.accessToken.jwtToken,
            userType: attributes['custom:usertype'],
          };
          dispatch({
            type: SIGN_IN,
            ...user,
          });
        });
      })
      .catch((err) => {
        setVerifyLoading(false);
        setErrorMessage(err.message);
        console.log(err);
      });
  };

  return (
    <ScrollView contentContainerStyle={styles.contentContainerStyle}>
      <View style={styles.mainContainer}>
        {!userReset && (
          <View style={styles.container}>
            <View style={styles.logo}>
              <Logo />
            </View>
            <View style={styles.headerContainer}>
              <HeaderOne title={HEADER_FORGOT_PASSWORD} />
            </View>
            <View style={styles.headerContainer}>
              <GalanoGrotesqueText style={styles.text}>
                {HEADER_ENTER_EMAIL}
              </GalanoGrotesqueText>
            </View>
            <Formik
              initialValues={{ email: '' }}
              onSubmit={(values) => resetPassword(values)}
              validationSchema={resetPasswordSchema}
            >
              {({
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isValid,
                touched,
                values,
              }) => (
                <View>
                  <EmailInput
                    errorMessage={touched.email && errors.email}
                    onBlur={handleBlur('email')}
                    onChangeText={handleChange('email')}
                    value={values.email}
                  />
                  <ContainedButton
                    loading={passwordLoading}
                    disabled={!isValid || passwordLoading}
                    type="outline"
                    title="Submit"
                    onPress={handleSubmit}
                  />
                  <>
                    {errorMessage && (
                      <GalanoGrotesqueText style={styles.errorText}>
                        {errorMessage}
                      </GalanoGrotesqueText>
                    )}
                  </>
                </View>
              )}
            </Formik>
          </View>
        )}
        {userReset && (
          <View style={styles.container}>
            <View
              style={{
                width: 250, // FIXME: This is a hack and not a long term solution
              }}
            >
              <HeaderOne title={HEADER_ENTER_CODE} />
            </View>
            <Formik
              initialValues={{ code: '', confirmPassword: '', newPassword: '' }}
              onSubmit={(values) => confirmResetPassword(values)}
              validationSchema={forgotPasswordSubmitSchema}
            >
              {({
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                isValid,
                touched,
                values,
              }) => (
                <View style={{ padding: 50 }}>
                  <VerificationCodeInput
                    errorMessage={touched.code && errors.code}
                    onBlur={handleBlur('code')}
                    onChangeText={handleChange('code')}
                    value={values.code}
                  />
                  <PasswordInput
                    errorMessage={touched.newPassword && errors.newPassword}
                    onBlur={handleBlur('newPassword')}
                    onChangeText={handleChange('newPassword')}
                    placeholderLabel="New password"
                    value={values.newPassword}
                  />
                  <PasswordInput
                    errorMessage={
                      touched.confirmPassword && errors.confirmPassword
                    }
                    onBlur={handleBlur('confirmPassword')}
                    onChangeText={handleChange('confirmPassword')}
                    placeholderLabel="Confirm password"
                    value={values.confirmPassword}
                  />
                  <ContainedButton
                    disabled={!isValid || verifyLoading}
                    loading={verifyLoading}
                    onPress={handleSubmit}
                    title="Verify"
                  />
                  <>
                    {errorMessage && (
                      <GalanoGrotesqueText style={styles.errorText}>
                        {errorMessage}
                      </GalanoGrotesqueText>
                    )}
                  </>
                </View>
              )}
            </Formik>
          </View>
        )}
      </View>
    </ScrollView>
  );
};

export default ForgotPasswordScreen;
